module.exports = [{
      plugin: require('/root/project/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
